// Polyfills
import 'requestidlecallback-polyfill'; // Safari

// Other
import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path.js';
setBasePath('/shoelace');

import './pages/app-fast';
import './components/header';
import '/node_modules/bootstrap-icons/font/bootstrap-icons.css'
import './styles/global.css';
import { router } from './router';

@customElement('app-index')
export class AppIndex extends LitElement {
  static styles = css`
    main {
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 16px;
    }
  `;

  firstUpdated() {
    router.addEventListener('route-changed', () => {
      if ("startViewTransition" in document) {
        (document as any).startViewTransition(() => this.requestUpdate());
      }
      else {
        this.requestUpdate();
      }
    });
  }

  render() {
    // router config can be round in src/router.ts
    return html`${router.render()}`;
  }
}
